import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfessionalsListComponent } from './professionals-list/professionals-list.component';
import { RenderersModule } from 'src/app/shared/renderers/renderers.module';
import { ProfessionalsFormComponent } from './professionals-form/professionals-form.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ProfessionalsListComponent,
    ProfessionalsFormComponent
  ],
  imports: [
    CommonModule,
    RenderersModule,
    SharedModule,
    NgSelectModule,
    NgxMaskModule,
    ReactiveFormsModule
  ]
})
export class ProfessionalsModule { }
